export default __webpack_public_path__ + "static/special-banner-cebe9dcb9ebbfe4d4493147bbfceca52.jpg";